export interface Package {
    /** unique identifier, use lowercase and underscores */
    id: string;
    /** marketing name of the package */
    title: string;
    /** number of stars (3 – 5) shown in UI badges, etc. */
    starRating: number;
    /** base price in USD; use null if TBA or dynamic */
    price: number | null;
    /** image URLs (add later) */
    images: string[];
    /** everything included in the base package */
    inclusions: string[];
    /** optional upsells the guest can tack on */
    addOns: { name: string; price: number }[];
    /** optional description for the package */
    description?: string;

   
}

export const packages: Package[] = [
    {
        id: "3_star_lt_general",
        title: "3 Star Lt. General",
        starRating: 3,
        price: 374,
        images: [
            "/img/3Stars.png",
            "/img/3Star1.png",

        ],
        inclusions: [
            "Safety/History Presentation",
            "5 Ton Transport",
            "Drive FV433 Abbot SPG",
            "STEN WWII Machine Gun",
            "Shop and Equipment Tour",
        ],
        addOns: [
            { name: "Passenger 1", price: 49 },
            { name: "Passenger 2", price: 49 },
            { name: "Single Car Crush", price: 649 },
            { name: "Double Car Crush", price: 849 }
        ],
        description: "Begin your day at Drive A Tank with safety training & brief history of the vehicles you will be driving. You will then be transported to our battlefield in our 5-ton troop transport where you will jump into the drivers’ hatch of an Abbot SPG. You will be driving not on an open field but in a densely wooded course that will test the limits of the vehicle and its operator, you. After testing your driving skills, you will come back up to our indoor gun range where you will fire an authentic STEN machine gun. Finish your day with a tour of our shop and equipment, learning even more about armored vehicles."
    },
    {
        id: "4_star_general",
        title: "4 Star General",
        starRating: 4,
        price: 649,
        images: [
            "/img/4Stars.png",
            "/img/4Star1.png",
        ],
        inclusions: [
            "Safety/History Presentation",
            "5 Ton Transport",
            "2 Passengers",
            "Drive FV433 Abbot SPG",
            "Drive FV432 APC",
            "<strong>Three</strong> Machine Guns",
            "Shop and Equipment Tour"
        ],
        addOns: [
            { name: "Single Car Crush", price: 649 },
            { name: "Double Car Crush", price: 849 }
        ],
        description: "Bring friends along with our 4 Star General Package that includes 2 passengers! You and your passengers will go through our safety and history presentation where you will then be transported via 5-ton to our battlefield. There you will take the driver’s seat of the Abbot SPG while your passengers occupy the Commander and Loader positions. After operating the Abbot, you and your comrades will move to our armored personnel carrier, the 432 APC. With all hatches closed, you will drive periscope around our course. After your driving experience, it’s back up to our indoor range to shoot machine guns. Here you will shoot a STEN, an M4, and our 1919 belt fed. End your day with a tour of the shop and other vehicles in our armory."
    },
    {
        id: "5_star_commander_in_chief",
        title: "5 Star Commander‑in‑Chief",
        starRating: 5,
        price: 2599,
        images: [
            "/img/5Stars.png",
            "/img/5Star1.png",
   
        ],
        inclusions: [
            "Safety/History Presentation",
            "5 Ton Transport",
            "2 Passengers",
            "Drive FV433 Abbot SPG",
            "Drive FV432 APC",
            "Drive T‑55 MBT or Mk 5 Centurion MBT",
            "Single Car Crush with Chieftain",
            "<strong>Four</strong> Machine Guns",
            "Barrett .50 Cal Anti‑Material Rifle",
            "Shop and Equipment Tour"
        ],
        addOns: [], // no standard upsells listed
        description: "Get the most out of your day with us when you purchase the 5 Star Commander in Chief. Start your day with a safety and history presentation as well as a 5-ton truck ride to the battlefield. There you will start by driving the Abbot SPG to get used to armor, then move onto the 432 APC to experience periscope driving. Then choose between our T-55 and Mk V Centurion and drive one lap around our wooded course. Cap off your driving experience by demolishing a car in our 121,000 lb. Chieftain Main Battle Tank. Head into our indoor range for the next part of your package. Four historic machine guns at the tip of your trigger finger. And that’s not all, round out your shooting with our Barrett .50 BMG that will leave you breathless. Wrap up your day with even more tank history as you take a tour of our shop and other vehicles."
    },
    {
        id: "ultimate_package",
        title: "Ultimate Package",
        starRating: 5,
        price: null, // set when final price decided
        images: [
            "/img/guns/_belt/minigun/minigun.jpg",
            "/img/Ultimate.png",

        ],
        inclusions: [
            "Safety/History Presentation",
            "5 Ton Transport",
            "2 Passengers",
            "Drive FV433 Abbot SPG",
            "Drive FV432 APC",
            "Drive T‑55 MBT",
            "Drive Centurion MBT",
            "Double Car Crush with Chieftain MBT",
            "<strong>13<strong> Machine Guns (incl. M2HB & M134 Minigun)",
            "Shop and Equipment Tour"
        ],
        addOns: [], // custom upsells can be added later
        description: "Can’t decide on what you want? The Ultimate package gives you a little bit of everything we offer at Drive A Tank. Start your day with a small safety and history presentation after which you will take a 5-ton truck ride down to our battlefield. There you will first drive the FV433 Abbot SPG to get a feel for driving armor. Then you will move to the FV432 APC where you will experience driving periscope as they did in battle. Then take your experience to the next level with driving one lap with the T-55 and the Mk 5 Centurion Main Battle Tank. Finally finish up your driving experience with a 121,000 pound Chieftain MBT as you experience a double car crush.Finish your ultimate experience with shooting thirteen of our historic machine guns. Start with the Sten and work your way up to our loudest and flashiest guns including the M2HB and the M134 Minigun."
    }
];
